import React, { useState } from "react";
import AppSelectionList from "../../../../components/AppSelectionList";
import AppText from "../../../../components/AppText";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const selectionItems = [
  {
    value: "math",
    label: "Mathematik",
  },
  {
    value: "bio",
    label: "Biologie",
    description: "2 Lektionen pro Woche",
  },
  {
    value: "chem",
    label: "Chemie",
    code: "CH",
    status: "Pflicht",
  },
  {
    value: "physics",
    label: "Physik",
    description: "Momentan nicht verfügbar",
    disabled: true,
  },
];

const niceToKnowItems = [
  "Offene Liste ohne eigenen Container; Dialog, Card oder Bereich kommt von aussen.",
  "Nutzt Checkboxen und ist für Mehrfachauswahl gedacht.",
  "Description, Leading und Trailing sind optional.",
  "MD ist Standard; SM für kompaktere Picker oder Dialoge.",
  "In v2 aktiv in Formular-, E-Mail-, Teacher- und Course-Auswahlbereichen.",
  "Suche, Tabs, Counter und Footer gehören in die übergeordnete Composition.",
];

function SelectionMeta({ children }) {
  return (
    <AppText as="span" variant="body-3" tone="tertiary" className="ds-docs-selection-list-preview__meta">
      {children}
    </AppText>
  );
}

export default function SelectionListsDocs() {
  const [selectedValues, setSelectedValues] = useState(["bio", "chem"]);

  return (
    <DocsSectionCard title="Selection Lists">
      <div className="ds-docs-spotlight-grid ds-docs-selection-list-layout">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-selection-list-preview">
            <AppSelectionList
              items={selectionItems}
              value={selectedValues}
              onChange={setSelectedValues}
              renderLeading={(item) => (item.code ? <SelectionMeta>{item.code}</SelectionMeta> : null)}
              renderTrailing={(item) => {
                if (item.status) {
                  return <SelectionMeta>{item.status}</SelectionMeta>;
                }

                if (selectedValues.includes(item.value)) {
                  return <SelectionMeta>Ausgewählt</SelectionMeta>;
                }

                return null;
              }}
            />
          </div>
        </DocsPreviewPanel>

        <div className="ds-docs-selection-list-side">
          <DocsNiceToKnow items={niceToKnowItems} />
        </div>

        <div className="ds-docs-selection-list-warning" aria-hidden="true">
          <span>Komponente im Ausbau!</span>
        </div>
      </div>
    </DocsSectionCard>
  );
}
